import { apiClient } from '@/services/api/apiClient';
import { ENDPOINTS } from '@/services/api/endpoints';
import { mapApiTaskToChairUi } from '@/features/pillarChair/services/pillarChairService';

/**
 * Load a task for leadership notification modal (pillar-level vs project-scoped).
 * @param {{ taskId: string, taskForceId: string, pillarId: string, projectId?: string|null }} coords
 * @param {string|null|undefined} currentUserId
 */
export async function fetchTaskForNotification(coords, currentUserId) {
    const { taskId, taskForceId, pillarId, projectId } = coords;
    if (!taskId || !taskForceId || !pillarId) {
        throw new Error(
            'This notice does not include enough location to load the task. A task force id and pillar id are required.',
        );
    }
    const uid = currentUserId != null ? String(currentUserId) : '';
    try {
        if (projectId) {
            const { data } = await apiClient.get(
                ENDPOINTS.HIERARCHY.TASKS.DETAIL(taskForceId, pillarId, projectId, taskId),
            );
            return mapApiTaskToChairUi(data, uid);
        }
        const { data } = await apiClient.get(
            ENDPOINTS.HIERARCHY.PILLAR_TASKS.DETAIL(taskForceId, pillarId, taskId),
        );
        return mapApiTaskToChairUi(data, uid);
    } catch (e) {
        const status = e?.response?.status;
        const msg = e?.response?.data?.message || e?.message;
        if (status === 403 || status === 401) {
            throw new Error('You do not have access to this task.');
        }
        if (status === 404) {
            throw new Error(
                msg ||
                    'Task not found. It may be under a project — the server needs to send projectId on the notification.',
            );
        }
        throw new Error(msg || 'Could not load task details.');
    }
}
